import { render, staticRenderFns } from "./InformationResidentComplex.vue?vue&type=template&id=61e8be55&scoped=true"
import script from "./InformationResidentComplex.vue?vue&type=script&lang=js"
export * from "./InformationResidentComplex.vue?vue&type=script&lang=js"
import style0 from "./InformationResidentComplex.vue?vue&type=style&index=0&id=61e8be55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8be55",
  null
  
)

export default component.exports